// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l3J_o"};